export const NUMBER_LIMT=1000000;
export const AMOUNT_LIMT=2147483647;
export const UI_DATE_FORMAT="YYYY/MM/DD"